// Fronted/src/services/contactService.js
import api from './api';

const contactService = {
  submitContactForm: async (contactData) => {
    try {
      const response = await api.post('/contact/send', contactData);
      return response.data;
    } catch (error) {
      console.error('Error submitting contact form:', error);
      throw error;
    }
  },

  getContactMessages: async () => {
    try {
      const response = await api.get('/contact/messages');
      console.log('Fetched contact messages:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching contact messages:', error);
      throw error;
    }
  },

  markMessageAsRead: async (messageId) => {
    try {
      const response = await api.put(`/contact/messages/${messageId}/read`);
      return response.data;
    } catch (error) {
      console.error(`Error marking message ${messageId} as read:`, error);
      throw error;
    }
  },

  deleteMessage: async (messageId) => {
    try {
      const response = await api.delete(`/contact/messages/${messageId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting message ${messageId}:`, error);
      throw error;
    }
  }
};

export default contactService; 